import {EmbedEvent} from 'embed/types/events'
import {NinchatEnvironmentConfig} from 'embed/types'
import i18n from 'i18next'
import {sendToParent} from './event'

type EmbedLanguageConfig = Pick<NinchatEnvironmentConfig, 'sessionKey' | 'translations'> & {language?: string}

export const applyEmbedLanguage = async (conf: EmbedLanguageConfig, targetOrigin: string) => {
    if (!conf.language && !conf.translations) {
        return
    }

    const language = conf.language || i18n.language
    try {
        await i18n.changeLanguage(language)
    } catch (error) {
        // A locale-load failure must not prevent the embed from mounting.
        console.warn('Could not load embed language', language, error)
    }

    if (conf.translations) {
        i18n.addResourceBundle(language, 'translation', conf.translations, true, true)
    }

    sendToParent({
        event: EmbedEvent.EmbedTranslations,
        lang: language,
        targetOrigin,
        translations: i18n.getResourceBundle(language, 'translation') || {},
    }, conf.sessionKey || '')
}
